const segmentSyncStatus = Object.freeze({
  NOT_IN_PROGRESS: 0,
  IN_PROGRESS: 1,
  DISABLED: 2,
  MANUALLY_DISABLED: 4
})

const isSegmentDisabled = status =>
  Number(status) === segmentSyncStatus.DISABLED ||
  Number(status) === segmentSyncStatus.MANUALLY_DISABLED

export { segmentSyncStatus, isSegmentDisabled }



// WEBPACK FOOTER //
// ./src/modules/audiences/enum/SegmentSyncStatusEnum.js